import BackgroundMusicModal from "./background-music-modal.component";

export default BackgroundMusicModal;
